// import clsx from 'clsx'
// import {KTIcon, toAbsoluteUrl} from '../../../helpers'
// import {HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher} from '../../../partials'
// import {useLayout} from '../../core'
// import {useAuth} from '../../../../app/modules/auth'

// const itemClass = 'ms-1 ms-md-4'
// const btnClass =
//   'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
// const userAvatarClass = 'symbol-35px'
// const btnIconClass = 'fs-2'

// const Navbar = () => {
//   const {currentUser, auth, isFacilityManager, isSupplyChainManager}: any = useAuth()
//   const image = isSupplyChainManager
//     ? auth?.data?.profileImage || ''
//     : isFacilityManager
//     ? toAbsoluteUrl('/media/avatars/facMan.jpeg')
//     : isSupplyChainManager
//     ? currentUser?.franchiseKycDoc?.filter((x) => x?.docType === 'SEC_DTI')?.[0]?.docUrl
//     : currentUser?.kycDocument?.filter((x) => x?.docType === 'SEC_DTI')?.[0]?.docUrl ||
//       currentUser?.kycDocument?.filter((x) => x?.docType === 'CLIENT_LOGO')?.[0]?.docUrl
//   const {config} = useLayout()
//   return (
//     <div className='app-navbar flex-shrink-0'>
//       {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
//         <Search />
//       </div>

//       <div className={clsx('app-navbar-item', itemClass)}>
//         <div id='kt_activities_toggle' className={btnClass}>
//           <KTIcon iconName='chart-simple' className={btnIconClass} />
//         </div>
//       </div>

//       <div className={clsx('app-navbar-item', itemClass)}>
//         <div
//           data-kt-menu-trigger="{default: 'click'}"
//           data-kt-menu-attach='parent'
//           data-kt-menu-placement='bottom-end'
//           className={btnClass}
//         >
//           <KTIcon iconName='element-plus' className={btnIconClass} />
//         </div>
//         <HeaderNotificationsMenu />
//       </div> */}

//       {/* <div className={clsx('app-navbar-item', itemClass)}>
//         <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
//           <KTIcon iconName='message-text-2' className={btnIconClass} />
//           <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
//         </div>
//       </div> */}

//       <div className={clsx('app-navbar-item', itemClass)}>
//         <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
//       </div>

//       <div className={clsx('app-navbar-item', itemClass)}>
//         <div
//           className={clsx('cursor-pointer symbol', userAvatarClass)}
//           data-kt-menu-trigger="{default: 'click'}"
//           data-kt-menu-attach='parent'
//           data-kt-menu-placement='bottom-end'
//         >
//           <img src={image || toAbsoluteUrl('/media/avatars/facMan.jpeg')} alt='' />
//         </div>
//         <HeaderUserMenu />
//       </div>

//       {config.app?.header?.default?.menu?.display && (
//         <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
//           <div
//             className='btn btn-icon btn-active-color-primary w-35px h-35px'
//             id='kt_app_header_menu_toggle'
//           >
//             <KTIcon iconName='text-align-left' className={btnIconClass} />
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }

// export {Navbar}




import clsx from 'clsx'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher } from '../../../partials'
import { useLayout } from '../../core'
import { useAuth } from '../../../../app/modules/auth'
import { useEffect } from 'react'

const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'

const Navbar = () => {
  const { currentUser, auth, isFacilityManager, isSupplyChainManager }: any = useAuth()
  const image = isSupplyChainManager
    ? auth?.data?.profileImage || ''
    : isFacilityManager
      ? toAbsoluteUrl('/media/avatars/facMan.jpeg')
      : isSupplyChainManager
        ? currentUser?.franchiseKycDoc?.filter((x) => x?.docType === 'SEC_DTI')?.[0]?.docUrl
        : currentUser?.kycDocument?.filter((x) => x?.docType === 'SEC_DTI')?.[0]?.docUrl ||
        currentUser?.kycDocument?.filter((x) => x?.docType === 'CLIENT_LOGO')?.[0]?.docUrl
  const { config } = useLayout()

  useEffect(() => {
    // Function to open drawer
    const openDrawer = () => {
      const drawer = document.getElementById('kt_activities')
      console.log('Opening drawer...', drawer) // Debug log

      if (drawer) {
        drawer.style.right = '0px'
        // Don't create overlay - let MasterLayout handle it
      }
    }

    // Function to close drawer
    const closeDrawer = () => {
      const drawer = document.getElementById('kt_activities')

      console.log('Closing drawer...', drawer) // Debug log

      if (drawer) {
        drawer.style.right = '-100%'
      }

      // Remove any manual overlays we might have created
      const overlays = document.querySelectorAll('#drawer-overlay')
      overlays.forEach(overlay => {
        if (overlay.parentNode) {
          overlay.parentNode.removeChild(overlay)
        }
      })

      document.body.style.overflow = ''
    }

    // Add event listeners
    const toggleButton = document.getElementById('kt_activities_toggle')
    console.log('Toggle button:', toggleButton) // Debug log

    if (toggleButton) {
      toggleButton.addEventListener('click', openDrawer)
    }

    // Setup close button with delay to ensure it's rendered
    const setupCloseButton = () => {
      const closeBtn = document.getElementById('kt_activities_close')
      if (closeBtn) {
        closeBtn.addEventListener('click', closeDrawer)
        console.log('Close button setup:', closeBtn) // Debug log
      }
    }

    // Try multiple times to find the close button
    setTimeout(setupCloseButton, 100)
    setTimeout(setupCloseButton, 500)
    setTimeout(setupCloseButton, 1000)

    // Also add escape key to close
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        closeDrawer()
      }
    }

    document.addEventListener('keydown', handleEscKey)

    // Cleanup function
    return () => {
      if (toggleButton) {
        toggleButton.removeEventListener('click', openDrawer)
      }

      const closeBtn = document.getElementById('kt_activities_close')
      if (closeBtn) {
        closeBtn.removeEventListener('click', closeDrawer)
      }

      document.removeEventListener('keydown', handleEscKey)

      // Clean up any overlays on unmount
      const overlays = document.querySelectorAll('#drawer-overlay')
      overlays.forEach(overlay => {
        if (overlay.parentNode) {
          overlay.parentNode.removeChild(overlay)
        }
      })

      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div className='app-navbar flex-shrink-0'>
      {/* Search */}
      {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div> */}

      {/* Activity Logs Trigger Button */}
      {/* Activity Logs Trigger Button - Only show for FRANCHISE_USER or PICKUP_POINT */}



      {(currentUser?.userType === "FRANCHISE_USER") && (
        <div className={clsx('app-navbar-item', itemClass)}>
          <span style={{
            backgroundColor: '#dc3545',
            color: 'white',
            fontSize: '10px',
            padding: '2px 6px',
            borderRadius: '4px',
            marginLeft: '8px',
            fontWeight: '500',
            verticalAlign: 'middle'
          }}>
            New
          </span>
          <div
            id='kt_activities_toggle'
            className={btnClass}
            style={{ cursor: 'pointer' }}
            title="Activity Logs"
          >
            <KTIcon iconName='chart-simple' className={btnIconClass} />
          </div>
        </div>
      )}






      {/* Notifications */}
      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={btnClass}
        >
          <KTIcon iconName='element-plus' className={btnIconClass} />
        </div>
        <HeaderNotificationsMenu />
      </div> */}

      {/* Chat */}
      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTIcon iconName='message-text-2' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div> */}

      {/* ActivityDrawer is now handled by MasterLayout - REMOVED FROM HERE */}

      {/* Theme Mode Switcher */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      {/* User Menu */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          {/* <img src={image || toAbsoluteUrl('/media/avatars/facMan.jpeg')} alt='' /> */}
          <img
            style={{ width: "35px", height: "35px", objectFit: "cover", borderRadius: "50%" }}
            src={
              currentUser?.userType === 'AUDITOR'
                ? currentUser?.kycDocument?.find((doc) => doc.docType === 'POE')?.docUrl || toAbsoluteUrl('/media/avatars/facMan.jpeg')
                : currentUser?.userType === 'CLIENT'
                  ? currentUser?.kycDocument?.find((doc) => doc.docType === 'POE')?.docUrl || toAbsoluteUrl('/media/avatars/facMan.jpeg')
                  : currentUser?.userType === 'CLIENT_USER'
                    ? currentUser?.personalDetails?.profileImage || toAbsoluteUrl('/media/avatars/facMan.jpeg')
                    : image || toAbsoluteUrl('/media/avatars/facMan.jpeg')
            }
            alt='Smart Hub'
          />

        </div>
        <HeaderUserMenu />
      </div>

      {/* Mobile Menu Toggle */}
      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export { Navbar }